import { forwardRef, useCallback } from "react";
import { clsx } from "clsx";

import { Text } from "../text/Text";

import "./Switch.css";

import type { ReactNode, ChangeEvent as ReactChangeEvent } from "react";

export interface SwitchChangeEvent {
  checked: boolean;
}

export interface SwitchProps {
  checked?: boolean;
  children?: ReactNode;
  disabled?: boolean;
  name?: string;
  readOnly?: boolean;
  value?: string;
  onChange?: (event: SwitchChangeEvent) => void;
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  function SwitchImpl(
    { checked = false, children, disabled, name, readOnly, value, onChange },
    ref,
  ) {
    const handleChange = useCallback(
      (e: ReactChangeEvent<HTMLInputElement>) => {
        onChange?.({ checked: e.target.checked });
      },
      [onChange],
    );

    return (
      <label
        className={clsx("Switch", {
          "Switch--disabled": disabled,
          "Switch--readonly": readOnly,
        })}
      >
        <input
          ref={ref}
          type={"checkbox"}
          role="switch"
          checked={checked}
          name={name}
          value={value}
          disabled={disabled}
          readOnly={readOnly}
          onChange={handleChange}
        />

        <div className="Switch__indicator">
          <div className="Switch__indicator-knob" />
        </div>

        <Text>{children}</Text>
      </label>
    );
  },
);
